import { PixelRatioImage, type PixelRatioImageProps } from "@/components/common/pixel-ratio-image";
import knowledgeEmptyImage from "@/assets/assets/knowledge-empty.webp";

export const KnowledgeEmptyImage = (props: Omit<PixelRatioImageProps, "images">) => {
  return (
    <PixelRatioImage
      images={[knowledgeEmptyImage]}
      {...props}
    />
  );
};

KnowledgeEmptyImage.displayName = 'KnowledgeEmptyImage';
